/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`).
 */
import { createElement, useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { createSoundingLayer } from './layer';
import { SoundingPopup } from './SoundingPopup';
import { startSoundingSync } from './sync';

export { refreshSondagens } from './sync';

export function useSoundingLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => startSoundingSync(), []);

  useEffect(() => {
    if (!map) return;
    const { layer, voo, dispose } = createSoundingLayer((dado) => createElement(SoundingPopup, { dado }));
    map.addLayer(layer);
    map.addLayer(voo);
    return () => {
      map.removeLayer(layer);
      map.removeLayer(voo);
      dispose();
    };
  }, [map]);
}
